import React from 'react';
import {
  HeaderActionsPopover as SharedHeaderActionsPopover,
  type HeaderActionsPopoverProps,
} from '../FieldActions';
import { classes } from './HeaderActionsPopover.st.css.js';

export function HeaderActionsPopover(props: HeaderActionsPopoverProps) {
  return <SharedHeaderActionsPopover {...props} className={classes.root} />;
}
